import Lottie from 'lottie-react';

import spinAnimation from '../lottie-files/spin-loader.json';
import catAnimation from '../lottie-files/cat-loader.json';
import catErrorAnimation from '../lottie-files/cat-error.json';
import savingAnimation from '../lottie-files/saving-loader.json';
import fileUploadingAnimation from '../lottie-files/file-uploading-loader.json';
import deleteAnimation from '../lottie-files/delete-loader.json';
import fileMovementAnimation from '../lottie-files/file-movement.json';
import horizontalLoader from '../lottie-files/horizontal-loader.json';
import loader2 from '../lottie-files/Loader-2.json';
import loader3 from '../lottie-files/Loader-3.json';
import loader4 from '../lottie-files/Loader-4.json';
import React from 'react';
import {LoaderIcon} from '../Iconpack';
import {cva, VariantProps} from 'class-variance-authority';
import {cn} from '../lib/utils';

export function SpinLoader({size = 'regular'}: {size?: 'small' | 'regular'}) {
    return (
        <Lottie
            animationData={spinAnimation}
            loop
            className={`${
                size === 'regular' ? 'h-12' : 'h-8'
            } absolute left-[50%] top-[50%] -translate-x-2/4 -translate-y-2/4`}
        />
    );
}

export function SavingLoaderBig() {
    return <Lottie animationData={savingAnimation} loop className={`relative h-[324px] w-[324px]`} />;
}

export function SavingLoader() {
    return <Lottie animationData={savingAnimation} loop className={`relative h-[172px] w-[172px]`} />;
}

export function CatLoader() {
    return <Lottie animationData={catAnimation} loop className='h-24' />;
}

export function CatError() {
    return <Lottie animationData={catErrorAnimation} loop className='h-24' />;
}

export function CatErrorBig() {
    return <Lottie animationData={catErrorAnimation} loop className='h-[351px] w-[343px]' />;
}

export function FileUploadingBig() {
    return <Lottie animationData={fileUploadingAnimation} loop className='h-[256px] w-[192px]' />;
}

export function DeleteAnimation() {
    return <Lottie animationData={deleteAnimation} loop className='flex items-center justify-center' />;
}

export function FileMovementAnimation() {
    return <Lottie animationData={fileMovementAnimation} loop className='flex items-center justify-center' />;
}

export function PulsatingCircleAnimation() {
    return <Lottie animationData={loader2} loop className='flex h-24 items-center justify-center' />;
}

export function PulsatingBarAnimation() {
    return <Lottie animationData={loader3} loop className='flex items-center justify-center' />;
}

export function SpinLoaderStyled() {
    return <Lottie animationData={loader4} loop className='flex h-24 items-center justify-center' />;
}

export function HorizontalLoader() {
    return <Lottie animationData={horizontalLoader} loop className='' />;
}

const spinLoaderVariants = cva('animate-spin text-gray-700', {
    variants: {
        size: {
            xsm: 'h-4 w-4',
            sm: 'h-8 w-8',
            md: 'h-12 w-12',
            lg: 'h-16 w-16',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});

interface SpinLoaderProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof spinLoaderVariants> {}

const CommonSpinLoader = React.forwardRef<HTMLDivElement, SpinLoaderProps>(({className, size = 'md'}, ref) => {
    return (
        <div ref={ref}>
            <LoaderIcon classNames={cn(spinLoaderVariants({size, className}))} />
        </div>
    );
});

const EllipsisLoader = () => {
    return (
        <div className='flex space-x-2'>
            <div className='h-2 w-2 animate-bounce rounded-full bg-gray-700 [animation-delay:-0.3s]'></div>
            <div className='h-2 w-2 animate-bounce rounded-full bg-gray-700 [animation-delay:-0.15s]'></div>
            <div className='h-2 w-2 animate-bounce rounded-full bg-gray-700'></div>
        </div>
    );
};

export {CommonSpinLoader, spinLoaderVariants, EllipsisLoader};
